module.exports = __webpack_public_path__ + "media/images/plans/icon-feature-prior-payment-d6e03a91028d5d0a9df30a1ed569e81c.png";